import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DividerComponent, ModalComponent, QrComponent, TileComponent } from '@tecalisdev/infinity';
import { DesignService } from 'src/app/shared/services/config/design.service';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';

@Component({
	selector: 'app-modal-help-document',
	templateUrl: './modal-help-document.component.html',
	styleUrls: ['./modal-help-document.component.scss'],
	imports: [ModalComponent, NgClass, TileComponent, DividerComponent, QrComponent, TranslatePipe, PwcsInlineSvgComponent],
})
export class ModalHelpDocumentComponent implements OnChanges {
	@Input() isVisible: boolean;
	@Input() url: string;
	@Input() operation: any;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public showHelpContent: boolean = true;

	constructor(public designService: DesignService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['isVisible']) {
			this.showHelpContent = true;
		}
	}

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
